import React from 'react';
import { Container, Divider } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';

const DropdownHeader = ({ children, ...rest }: Types.ContainerProps) => (
  <>
    <Container paddingX="5" paddingBottom="3" paddingTop="1" {...rest}>
      {children}
    </Container>
    <Divider marginBottom="2" />
  </>
);

DropdownHeader.displayName = 'DropdownHeader';
export default DropdownHeader;
